<template>
  <div id="ssh-generate">
    <el-dialog
      title="Create a pair of cryptographic keys"
      width="70%"
      :visible.sync="localVisible"
      @close="$emit('update:visible', false)"
    >
      <h4>
        SSH keys are generated in pairs and stored in plain-text files.
        The public part is saved on runstack.
      </h4>

      <el-alert
        type="error"
        title="Do not share your private key with others"
        description="The private key is stored on your local computer and should be kept secure,
          with permissions set so that no other users on your computer can read the file."
        :closable="false"
      />

      <div class="generate">
        <el-button type="primary" @click="generate">Download your private key</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fileSaver from 'file-saver'

export default {
  props: {
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      localVisible: this.visible,
      filename: 'runstack.private.txt',
      type: 'text/plain;charset=utf-8'
    }
  },
  methods: {
    generate () {
      this.loading = true
      this.$store.dispatch('generateKey')
        .then((res) => {
          fileSaver.saveAs(new Blob([res.data]), this.filename, { type: this.type })
          setTimeout(() => this.$store.dispatch('getUser').catch(() => {}), 500)

          this.loading = false
          this.$emit('update:visible', false)
          this.$message({
            message: 'Please allow up to 60 seconds for changes to take effect on servers.',
            type: 'success'
          })
        })
    }
  },
  watch: {
    visible (value) {
      this.localVisible = value
    }
  }
}
</script>

<style lang="scss" scoped>
  .generate {
    margin-top: 25px;
    text-align: center;
  }
</style>
